function FourOFour() {
  return (
    <div className="flex justify-center rounded-lg items-center p-6 m-6 py-24 shadow-green-500/50 border shadow-md">
      <h1 className="text-4xl font-bold text-indigo-600">
        Sorry, page not found ! ! !
      </h1>
    </div>
  );
}

export default FourOFour;
